import React from "react";
import { useForm, Controller } from "react-hook-form";
import {Grid, Typography, Button, TextField, Box, CircularProgress, MenuItem} from '@mui/material';
import {CustomModal, CustomSnackbar} from '../../../SharedComponents';
import {updateBankAccount, getBankAccount} from 'shared/src/api/accounts';
import { ACCOUNT_STATE } from 'shared/src/constants';

const requireErrorMessage = "Este campo es requerido";
const successMessage = "La Cuenta Bancaria se ha actualizado con exito"
const errorMessage = "Ha ocurrido un error";

const defaultValuesFordateField = {
    state: '',
}


export default function UpdateBankAccountStatusModal(props) {

    const { 
        getAccountlistFromService,
        BankAccountId, 
        open,
        setOpen,
        userId
    } = props;

    const [messageForAlert, setMessageForAlert] = React.useState({});
    const [opeAlert, setOpenAlert] = React.useState(false);
    const [actionButtonDisabled, setActionButtonDisabled] = React.useState(false);

    const handleClose = (_, reason) => {
        if(reason === "backdropClick") return;
        setActionButtonDisabled(false);
        reset(defaultValuesFordateField);
        setOpen(false);
    };

    const { control, handleSubmit, reset } = useForm({
        defaultValues: defaultValuesFordateField,
    });

    const handleOnSubmit = async dataForm =>{
        console.log(dataForm);
        setActionButtonDisabled(true);

        try {
            const { status } = await updateBankAccount(userId, BankAccountId, dataForm);

            if(status === 200) {
                setMessageForAlert({message:successMessage,severity:"success" });
                
            }else {
                setMessageForAlert({message:errorMessage,severity:"error" });
            }
        } catch (error) {
            console.log(error);
            setMessageForAlert({message:errorMessage,severity:"error" });
        }
        
        setOpenAlert(true);
        getAccountlistFromService();
        reset(defaultValuesFordateField);
        handleClose(); // to close modal
    }

    // for small notification
    const handleCloseAlert = (e, reason)=> {
        if (reason === 'clickaway') return;
        setOpenAlert(false);
    }

    const getBankAccountInformation =  async () => {
        setActionButtonDisabled(true);
        const { data: {data} } = await getBankAccount(userId, BankAccountId);
        reset({...defaultValuesFordateField, state: data.state});
        setActionButtonDisabled(false);
    }

    React.useEffect(() => {
        getBankAccountInformation();
    },[]);

    return(
        <>
            <CustomModal handleClose={handleClose} open={open} customStyles={{width:'400px'}}>
                <form onSubmit={handleSubmit(handleOnSubmit)}>
                    <Grid container alignItems="center" justify="center" direction="row" spacing={3}>
                        <Grid item md={12}>
                            <Typography variant="h6" sx={{mb:2, textAlign: 'center'}}>
                                Actualizar status de Cuenta Bancaria
                            </Typography>
                        </Grid>
                        <Grid item md={12}>
                            <Controller
                                name="state"
                                control={control}
                                rules={
                                    {
                                        required: requireErrorMessage,
                                    }
                                }
                                render={
                                    ({ field, fieldState: { invalid, error,  }}) =>(
                                    <TextField
                                        disabled={actionButtonDisabled}
                                        fullWidth
                                        select
                                        label="Estado *"
                                        error={invalid}
                                        helperText={error?.message}
                                        {...field}
                                        inputRef={field.ref}
                                    >
                                        <MenuItem key="" value="">
                                            --
                                        </MenuItem>
                                        {Object.entries(ACCOUNT_STATE).map(([key,value]) => <MenuItem key={key} value={key}>{value}</MenuItem>)}
                                    </TextField>)
                                }
                            />
                        </Grid>
                        <Grid item md={12} sx={{display: 'flex', justifyContent: 'center'}}>
                            <Button onClick={handleClose} variant="contained" color="error" sx={{mr:1}} disableElevation >Cancelar</Button>
                            <Box sx={{position: 'relative' }}>
                                <Button variant="contained" color="primary" type="submit" disabled={actionButtonDisabled}>
                                    Aceptar
                                </Button>
                                {actionButtonDisabled && (
                                    <CircularProgress
                                    size={24}
                                    sx={{
                                        position: 'absolute',
                                        top: '50%',
                                        left: '50%',
                                        marginTop: '-12px',
                                        marginLeft: '-12px',
                                    }}
                                    />
                                )}
                            </Box>
                        </Grid>
                    </Grid>
                </form>
            </CustomModal>
            <CustomSnackbar opeSnackbar={ opeAlert } messageForAlert={messageForAlert} handleCloseAlert={handleCloseAlert}/>
        </>
    );
}